export default function CTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <i className="ri-rocket-line text-yellow-400"></i>
          <span className="text-sm font-semibold text-white">GET STARTED TODAY</span>
        </div>

        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Transform Your E-Commerce Experience?
        </h2>

        <p className="text-xl text-gray-200 mb-12 max-w-3xl mx-auto">
          Join thousands of successful sellers and millions of happy customers on the most intelligent marketplace platform. Start your journey today—it's free to get started!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button className="px-10 py-5 bg-white text-indigo-600 rounded-xl hover:shadow-2xl transition-all font-bold text-lg cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2">
            <span>Start Selling Now</span>
            <i className="ri-arrow-right-line"></i>
          </button>
          <button className="px-10 py-5 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-xl hover:bg-white/20 transition-all font-bold text-lg cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2">
            <i className="ri-play-circle-line text-2xl"></i>
            <span>Watch Demo</span>
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center space-x-2">
            <i className="ri-check-line text-green-400 text-xl"></i>
            <span>No credit card required</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-check-line text-green-400 text-xl"></i>
            <span>Free 30-day trial</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-check-line text-green-400 text-xl"></i>
            <span>Cancel anytime</span>
          </div>
        </div>
      </div>
    </section>
  );
}
